export default __webpack_public_path__ + "static/media/calendarIcon.3ae13246.svg";